import { historicalVolSeries, numericExtent } from "../utils";
const HV = {
    name: "HV",
    compute: (bars, period = 20, annualize = true) => {
        return historicalVolSeries(bars.map((b) => b.close), period, annualize);
    },
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default HV;
